import "./ProfileComponent.scss";
import "./ProfileComponentMobile.scss";
import React, { useEffect, useState, useRef } from "react";
import BirthdatePicker from "./BirthdatePicker";
function ProfileComponent() {
  const fileInputRef = useRef(null);
  const [loading, setLoading] = useState(true);

  // Editable state
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [contact, setContact] = useState("");
  const [gender, setGender] = useState("");
  const [birthdate, setBirthdate] = useState(""); // YYYY-MM-DD
  const [profilepic, setProfilepic] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);

  // Keep original data for cancel
  const [originalData, setOriginalData] = useState({});
  const [editmode, setEditmode] = useState(false);

  // ✅ FIXED DATE FORMAT (ISO for input[type=date])
  const dateFormatted = (date) => {
    if (!date) return "";
    const d = new Date(date);
    return d.toISOString().split("T")[0]; // YYYY-MM-DD
  };
  const normalizeDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    if (isNaN(d.getTime())) return "";
    return d.toISOString().split("T")[0];
  };

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_URL}api/auth/customer-profile`, {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.CP_ID) {
          const formattedData = {
            cpId: data.CP_ID,
            firstName: data.CP_Firstname || "",
            lastName: data.CP_Lastname || "",
            email: data.CP_Emailaddress || "",
            contact: data.CP_Contactnumber || "",
            gender: data.CP_Gender || "",
            birthdate: normalizeDate(data.CP_Birthdate),
            profilepic: data.CP_Profilepicpath || "",
          };

          setFirstName(formattedData.firstName);
          setLastName(formattedData.lastName);
          setEmail(formattedData.email);
          setContact(formattedData.contact);
          setGender(formattedData.gender);
          setBirthdate(formattedData.birthdate);
          setProfilepic(formattedData.profilepic);
          setOriginalData(formattedData);
        }
      })
      .finally(() => setLoading(false));
    console.log("Profile pic path: ", profilepic);
  }, []);

  const handleEdit = () => {
    setOriginalData({
      cpId: originalData.cpId,
      firstName,
      lastName,
      email,
      contact,
      gender,
      birthdate,
      profilepic,
    });
    setEditmode(true);
  };

  const handleCancel = () => {
    setFirstName(originalData.firstName);
    setLastName(originalData.lastName);
    setEmail(originalData.email);
    setContact(originalData.contact);
    setGender(originalData.gender);
    setBirthdate(originalData.birthdate);
    setProfilepic(originalData.profilepic);
    setSelectedFile(null);
    setEditmode(false);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedExt = ["jpg", "jpeg", "png", "heic", "heif", "webp"];
    const ext = file.name.split(".").pop().toLowerCase();

    if (!allowedExt.includes(ext)) {
      alert("Allowed image types: JPG, PNG, HEIC, WEBP");
      return;
    }

    setSelectedFile(file);

    if (file.type.startsWith("image/") && !["heic", "heif"].includes(ext)) {
      setProfilepic(URL.createObjectURL(file));
    } else {
      setProfilepic(originalData.profilepic);
    }
  };

  const handleSelectImage = () => {
    fileInputRef.current.click();
  };
  const saveFormDataAsText = (formData) => {
    const lines = [];

    for (let [key, value] of formData.entries()) {
      if (value instanceof File) {
        lines.push(
          `${key}: FILE -> ${value.name}, ${value.type}, ${value.size} bytes`,
        );
      } else {
        lines.push(`${key}: ${value}`);
      }
    }

    const blob = new Blob([lines.join("\n")], { type: "text/plain" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "formdata.txt";
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const today = new Date();
  const minYear = today.getFullYear() - 15;
  const maxDate = `${minYear}-${String(today.getMonth() + 1).padStart(
    2,
    "0",
  )}-${String(today.getDate()).padStart(2, "0")}`;

  const handleSave = async () => {
    try {
      const formData = new FormData();
      formData.append("cpId", originalData.cpId);
      formData.append("firstName", firstName);
      formData.append("lastName", lastName);
      formData.append("birthdate", birthdate);
      formData.append("email", email);
      formData.append("contact", contact);
      formData.append("gender", gender);

      if (selectedFile) {
        formData.append("profilePic", selectedFile);
      } else {
        const filename = originalData.profilepic?.split(/[/\\]/).pop();
        formData.append("profilePicPath", filename || "");
      }

      // ✅ SAVE FORMDATA AS TEXT FILE
      //saveFormDataAsText(formData);
      //alert(`${process.env.REACT_APP_BASE_URL}api/auth/update-profile`);

      const res = await fetch(
        `https://littlekidinside.shop/api/auth/update-profile`,
        {
          method: "POST",
          body: formData,
          credentials: "include",
        },
      );
      const data = await res.json();

      if (!res.ok) {
        alert(data.error || "Profile update failed");
        return;
      }

      alert("Profile updated successfully.");
      setEditmode(false);
    } catch (err) {
      console.error("Profile update error:", err);

      // optional: save error to file
      const errorMessage = `Profile update error:\n${err}\n${err.stack}`;
      const blob = new Blob([errorMessage], { type: "text/plain" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "error_log.txt";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }
  };

  if (loading) return <p>Loading profile...</p>;
  const getProfileImage = (path) => {
    console.log("getProfileImage path: ", path);
    if (!path || path === "default-profile-pic") {
      console.log("Returning default profile pic");
      return "/Assets/Profile/default-profile-pic.png";
    }

    // Full external URL (Google, Facebook, etc.)
    if (path.startsWith("http")) {
      console.log("Returning full URL profile pic");
      return path;
    }

    // Google image ID (not real local file)
    if (path.includes("=") && path.length > 50) {
      console.log("Returning Google image ID profile pic");
      return `https://lh3.googleusercontent.com/a/${path}`;
    }

    // Local uploaded image
    console.log("Returning local uploaded profile pic");
    return `/Assets/Profile/${path}.png`;
  };
  return (
    //<img
    //            src={
    //            selectedFile
    //            ? URL.createObjectURL(selectedFile) // preview selected
    //          : profilepic
    //          ? profilepic.startsWith("http")
    //          ? profilepic
    //        : `${process.env.REACT_APP_BASE_URL}Assets/Profile/${profilepic}`
    //    : "/Assets/Profile/default-profile-pic.png"
    //}
    //alt="Profile"
    ///>
    <>
      <div className="is-pc-container">
        <div className="is-pc-header">
          <div className="is-pc-header-wrapper">MY PROFILE</div>
          <div className="is-pc-edit-button-wrapper">
            <button
              style={{ display: editmode ? "none" : "block" }}
              onClick={handleEdit}
            >
              Edit Information
            </button>
          </div>
        </div>

        <div className="is-pc-info2">
          <div className="is-pc-info-image">
            <div className="is-pc-info-image-selection">
              <img src={getProfileImage(profilepic)} alt="profile" />
              {editmode && (
                <div className="image-selection-button-wrapper">
                  <button onClick={handleSelectImage}>SELECT IMAGE</button>
                  <input
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                    accept=".jpg,.jpeg,.png"
                  />
                  <p>FILE EXTENSION: .JPG, .JPEG, .PNG</p>
                </div>
              )}
            </div>
          </div>

          <div className="is-pc-info-form">
            <table className="is-pc-info-table">
              <tbody>
                <tr>
                  <td className="label">Last Name:</td>
                  <td>
                    {!editmode ? (
                      <p>{lastName}</p>
                    ) : (
                      <input
                        type="text"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                      />
                    )}
                  </td>
                </tr>
                <tr>
                  <td className="label">First Name:</td>
                  <td>
                    {!editmode ? (
                      <p>{firstName}</p>
                    ) : (
                      <input
                        type="text"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                      />
                    )}
                  </td>
                </tr>
                <tr>
                  <td className="label">Birth date:</td>
                  <td>
                    {!editmode ? (
                      <p>{birthdate}</p>
                    ) : (
                      <input
                        className="date"
                        type="date"
                        max={maxDate} // user must be born on or before this date
                        value={birthdate}
                        onChange={(e) =>
                          setBirthdate(normalizeDate(e.target.value))
                        }
                      />
                    )}
                  </td>
                </tr>
                <tr>
                  <td className="label">Gender:</td>
                  <td>
                    {!editmode ? (
                      <p>{gender === "other" ? "Prefer not to say" : gender}</p>
                    ) : (
                      <div className="gender-group">
                        <label>
                          <input
                            type="radio"
                            name="gender"
                            value="male"
                            checked={gender === "male"}
                            onChange={(e) => setGender(e.target.value)}
                          />
                          <span>Male</span>
                        </label>

                        <label>
                          <input
                            type="radio"
                            name="gender"
                            value="female"
                            checked={gender === "female"}
                            onChange={(e) => setGender(e.target.value)}
                          />
                          <span>Female</span>
                        </label>

                        <label>
                          <input
                            type="radio"
                            name="gender"
                            value="other"
                            checked={gender === "other"}
                            onChange={(e) => setGender(e.target.value)}
                          />
                          <span className="text">Prefer not to say.</span>
                        </label>
                      </div>
                    )}
                  </td>
                </tr>
                <tr>
                  <td className="label">Email Address:</td>
                  <td>
                    {!editmode ? (
                      <p>{email}</p>
                    ) : (
                      <input
                        type="text"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    )}
                  </td>
                </tr>
                <tr>
                  <td className="label">Contact Number:</td>
                  <td>
                    {!editmode ? (
                      <p>{contact}</p>
                    ) : (
                      <input
                        type="text"
                        value={contact}
                        onChange={(e) => {
                          // Remove all non-digit characters
                          const onlyDigits = e.target.value
                            .replace(/\D/g, "")
                            .slice(0, 11);
                          setContact(onlyDigits);
                        }}
                      />
                    )}
                  </td>
                </tr>
              </tbody>
            </table>

            {editmode && (
              <div className="is-pc-info-action-button">
                <button className="action-save" onClick={handleSave}>
                  SAVE
                </button>
                <button onClick={handleCancel} className="action-cancel">
                  CANCEL
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default ProfileComponent;
